import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
const FeatureSection = lazy(() => import("./FeatureSection"));
const QCWorkflowSection = lazy(() => import("./QCWorkflowSection"));
const QMSBenefits = lazy(() => import("./QMSBenefits"));

const QualityManagementSystem = () => {
  return (
    <>
      <Helmet>
        <title>
          Quality Management System |  Laboratory QC Software | Winglo
        </title>

        <meta
          name="description"
          content="Winglo Quality  Management System ensures accurate lab results with automated QC workflow, real-time monitoring, and compliance-ready reporting."
        />

        <meta
          name="keywords"
          content="Quality Management System, laboratory QC software, Levey Jennings chart, lab quality management, QC automation, healthcare quality control"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <FeatureSection />
         <QCWorkflowSection />
         <QMSBenefits /> 
      </Suspense>
    </>
  );
};

export default QualityManagementSystem;